import { render, staticRenderFns } from "./WorkWelcome.vue?vue&type=template&id=0ecad4e8&"
import script from "./WorkWelcome.vue?vue&type=script&lang=js&"
export * from "./WorkWelcome.vue?vue&type=script&lang=js&"
import style0 from "./WorkWelcome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports